// @ts-expect-error Untyped module
import Cookies from 'js-cookie'; // todo move this function to cookieUtils and delete the file.

export const hasAcceptedCookies = () => Cookies.get('__hs_opt_out') === 'no' || false;